export const sentryIgnoreErrors = ['__adroll is not defined'];
